export default "__VITE_ASSET__Cb7BG1nK__"